module.exports = __webpack_public_path__ + "content/7e5d96a65ac78f789e7d418a85af1f9d.png";